import React, { memo, useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import moment from 'utils/momentInstanse'

import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import IconButton from '@material-ui/core/IconButton'

import HeatmapChart from 'components/HeatmapChart/HeatmapChart'
import Title from 'components/CommonUI/Title/Title'

import {
  getHeatMapData,
  getHeatMapDataSelector,
  getFacilityIdSelector,
  getIsFetchingHeatMapSelector,
  getHeatmapSelectedTimeStampSelector,
  setHeatmapTimestamp,
} from 'redux/reducers/facility'
import { useShallowEqualSelector } from 'custom-hooks'
import { heatmapMapper } from 'utils/simpleFacilityMapper'

export const categoriesHeatmap = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]

const HeatMapSection = () => {
  const dispatch = useDispatch()
  const id = useShallowEqualSelector(getFacilityIdSelector)

  const heatMapData = useShallowEqualSelector(getHeatMapDataSelector)

  const selectedTimestamp = useShallowEqualSelector(
    getHeatmapSelectedTimeStampSelector
  )

  const isFetchingHeatMap = useShallowEqualSelector(
    getIsFetchingHeatMapSelector
  )

  const seriesY = useMemo(() => heatmapMapper(heatMapData), [heatMapData])

  const handleChangeWeek = (switchType) => () => {
    switch (switchType) {
      case 'next':
        dispatch(
          setHeatmapTimestamp(
            moment.unix(selectedTimestamp).add(1, 'weeks').unix()
          )
        )
        break
      case 'prev':
        dispatch(
          setHeatmapTimestamp(
            moment.unix(selectedTimestamp).subtract(1, 'weeks').unix()
          )
        )
        break
      default:
        dispatch(setHeatmapTimestamp(moment().unix()))
        break
    }
  }

  const _categoriesX = categoriesHeatmap.map(
    (dayName, index) =>
      `${dayName} ${moment
        .unix(selectedTimestamp)
        .isoWeekday(index + 1)
        .format('DD')}`
  )

  const disableNextButton =
    moment.unix(selectedTimestamp).add(1, 'weeks').startOf('isoWeek').unix() >
    moment().unix()

  useEffect(() => {
    if (id) {
      dispatch(getHeatMapData())
    }
  }, [dispatch, id])

  return (
    <div className="consaption_chart_container">
      <div className="title_container">
        <Title
          title="Heatmap"
          component="h2"
          className="heatmap_title"
          subTitle={moment.unix(selectedTimestamp).format('MMMM YYYY')}
          classNameSubTitle="title_date"
        />
        <div className="week_switch_control_container">
          <IconButton
            onClick={handleChangeWeek('prev')}
            className="week_switch_control_button"
          >
            <ArrowBackIcon className="icon" />
          </IconButton>
          <IconButton
            onClick={handleChangeWeek('current')}
            className="week_switch_control_button current"
          >
            <span className="icon text_content">Current Week</span>
          </IconButton>
          <IconButton
            onClick={handleChangeWeek('next')}
            className="week_switch_control_button"
            disabled={disableNextButton}
          >
            <ArrowForwardIcon className="icon" />
          </IconButton>
        </div>
      </div>
      <HeatmapChart
        seriesY={seriesY}
        categoriesX={_categoriesX}
        isFetching={isFetchingHeatMap}
        classNameContainer="facility_heatmap_container"
      />
    </div>
  )
}

export default memo(HeatMapSection)
